@if (car(); as car) {
  @for (listingId of [car.id]; track listingId) {
  <div class="carousel-wrapper position-relative">
    <div
      [id]="carouselId + car.id"
      class="carousel slide ltr-mode"
      (slid.bs.carousel)="onSlideChanged($event)"
      data-bs-touch="false"
      data-bs-interval="false"
    >
      @if (displayIndicator && car.pictures.length > 1) {
        <div class="carousel-indicators thumbs-wrapper">
          <div class="thumbs-viewport">
            <div class="thumbs-track" [style.transform]="'translateX(-' + translateX + 'px)'">
              @for (pic of car.pictures; track pic; let i = $index) {
                <button
                  type="button"
                  loading="lazy"
                  [attr.data-bs-target]="'#' + carouselId + car.id"
                  [attr.data-bs-slide-to]="i"
                  [class.active]="i === activeIndex"
                  (click)="onThumbClick(i)"
                  class="thumb-btn"
                >
                  <img [src]="pic" class="thumb d-block" />
                </button>
              }
            </div>
          </div>
        </div>
      }
      <div class="carousel-inner rounded">
        @if (car.pictures !== undefined && car.pictures.length > 0) {
          <div
            class="carousel-item"
            *ngFor="let pic of car.pictures; let i = index"
            [class.active]="i === 0"
          >
            <div class="image-wrapper">
              <img
                [src]="pic"
                loading="lazy"
                class="d-block w-100"
                [ngClass]="{ cover: imagClass === 'cover', contain: imagClass === 'contain' }"
                alt="{{ car.name }}"
                (click)="openModal(i)"
              />
              @if (listingCard && carouselId !== 'carModal') {
                <span class="listing-sale-badge">{{
                  car.isForRent ? ('FOR_RENT' | translate) : ('FOR_SALE' | translate)
                }}</span>
              }
              <!-- Sold overlay -->
              @if (car.isExpired) {
                <div class="sold-overlay">
                  <span class="sold-text text-primary">{{ 'EXPIRED' | translate }}</span>
                </div>
              } @else if (car.status === statuses.Sold) {
                <div class="sold-overlay">
                  <span class="sold-text text-primary">{{ 'SOLD' | translate }}</span>
                </div>
              } @else {
                @if (displayLikeButton && carouselId !== 'carModal') {
                  <span
                    class="position-absolute top-0 end-0 text-dark bg-primary rounded like-button m-2"
                    (click)="toggleLike($event)"
                  >
                    @if (localCar(); as localCar) {
                      <span class="badge fs-6 p-1 text-dark">
                        <i [class]="localCar.liked ? 'bi bi-heart-fill' : 'bi bi-heart'"></i>
                      </span>
                    }
                  </span>
                }
              }
              @if (carouselId !== 'carModal') {
                <span
                  class="position-absolute top-0 m-2"
                  [class.start-0]="!listingCard"
                  [class.listing-price-badges]="listingCard"
                >
                  <span class="bg-primary text-dark rounded mx-1 badge fs-6 p-1"
                    ><app-price [price]="car.price"></app-price
                  ></span>
                  @if (!listingCard) {
                    <span class="bg-primary text-dark rounded badge fs-6 p-1">{{
                      car.isForRent ? ('FOR_RENT' | translate) : ('FOR_SALE' | translate)
                    }}</span>
                  }
                </span>
              }
            </div>
          </div>
        }
      </div>
      @if (car.pictures.length > 1) {
        <div class="image-counter">{{ activeIndex + 1 }} / {{ car.pictures.length }}</div>
        <button
          class="carousel-control-prev"
          type="button"
          [attr.data-bs-target]="'#' + carouselId + car.id"
          data-bs-slide="prev"
          (click)="next($event)"
        >
          <span class="carousel-control-prev-icon"></span>
        </button>
        <button
          class="carousel-control-next"
          type="button"
          [attr.data-bs-target]="'#' + carouselId + car.id"
          data-bs-slide="next"
          (click)="next($event)"
        >
          <span class="carousel-control-next-icon"></span>
        </button>
      }
    </div>
  </div>
}
}
